import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=e8e65a1a&scoped=true"
import script from "./OrderDetailTable.vue?vue&type=script&lang=js"
export * from "./OrderDetailTable.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTable.vue?vue&type=style&index=0&id=e8e65a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e65a1a",
  null
  
)

export default component.exports